/**
 * Safely retrieve Vite environment variables
 * Handles both production (Vite) and test (Jest) environments
 */
export function getEnv(key: string, defaultValue: string = ""): string {
  try {
    // For Vite builds, use import.meta.env
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const meta = (globalThis as any).import?.meta;
    if (meta && meta.env && meta.env[key]) {
      return meta.env[key] as string;
    }
  } catch (e) {
    // Fall through to process.env
  }

  try {
    // For Jest/Node environments, try process.env
    if (process.env && process.env[`VITE_${key}`]) {
      return process.env[`VITE_${key}`] as string;
    }
  } catch (e) {
    return defaultValue;
  }

  return defaultValue;
}
